import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Common/Breadcrumb';

const ImmigrationServices = () => {
  const services = [
    {
      id: 1,
      title: "Work Permits",
      description: "Expert assistance with both open and employer-specific work permits, including LMIA-based applications.",
      icon: "fas fa-briefcase"
    },
    {
      id: 2,
      title: "Permanent Residency (PR)",
      description: "Exclusive options and full-service support for PR applications under Express Entry, Provincial Nominee Programs (PNP), Family Sponsorships, and AIP/RNIP streams.",
      icon: "fas fa-home"
    },
    {
      id: 3,
      title: "Visitor & Super Visas",
      description: "Guidance for individuals and families applying for tourist or long-term family visas, including Super Visa applications for parents and grandparents.",
      icon: "fas fa-plane"
    },
    {
      id: 4,
      title: "LMIA Assistance",
      description: "Helping employers and foreign workers with the Labour Market Impact Assessment process to facilitate Canadian job offers.",
      icon: "fas fa-clipboard-check"
    },
    {
      id: 5,
      title: "Spousal Sponsorship",
      description: "Specialized help with both Inland and Outland sponsorship applications to reunite spouses and partners in Canada.",
      icon: "fas fa-heart"
    }
  ];

  return (
    <>
      <Breadcrumb title="Immigration" />
      
      <div className="container-fluid service overflow-hidden pt-5">
      <div className="container py-5">
        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">Immigration Services</h5>
          </div>
          <h1 className="display-5 mb-4">We offer end-to-end support for a wide range of Canadian immigration pathways.</h1>
          <p className="mb-0">From initial eligibility assessments to final document submission and post-landing support, our team provides personalized guidance at every stage. Whether you're applying for a work permit, permanent residency, visitor visa, or exploring family and spousal sponsorships, we simplify the complex process to ensure a smooth and successful journey to Canada.</p>
        </div>
      </div>
      </div>
      

      {/* Services Section */}
      <div id="services" className="container-fluid">
        <div className="container py-5">
          <div className="row g-4">
            {services.map((service) => (
              <div key={service.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${service.id * 0.1}s`}>
                <div className="service-card h-100 bg-white rounded shadow-sm p-4 border-0 hover-lift">
                  <div className="text-center mb-4">
                    <div className="service-icon bg-primary rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                      <i className={`${service.icon} fa-2x text-white`}></i>
                    </div>
                  </div>
                  <h4 className="text-primary mb-3 text-center">{service.title}</h4>
                  <p className="text-muted text-center mb-0">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact CTA Section */}
      <div className="container-fluid bg-light py-5">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center wow fadeInUp" data-wow-delay="0.1s">
              <h2 className="text-primary mb-4">Have questions about your immigration options?</h2>
              <p className="text-muted fs-5 mb-4">Contact us today for personalized guidance.</p>
              <Link to="/contact" className="btn btn-primary btn-lg rounded-pill px-5">Contact Us</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImmigrationServices; 